import { render, staticRenderFns } from "./OrderSubmittedModal.vue?vue&type=template&id=7b4cbe1a&scoped=true"
import script from "./OrderSubmittedModal.vue?vue&type=script&lang=ts"
export * from "./OrderSubmittedModal.vue?vue&type=script&lang=ts"
import style0 from "./OrderSubmittedModal.vue?vue&type=style&index=0&id=7b4cbe1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4cbe1a",
  null
  
)

export default component.exports